import { FunctionComponent } from "react";

interface IProps {
  stroke?: string;
  width?: string;
  height?: string;
}

const BurgerMenu: FunctionComponent<IProps> = ({ width = "19", height = "13" }) => (
  <svg width={width} height={height} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5 13.5H0.5" stroke="#111111" strokeMiterlimit="10" strokeLinecap="round" />
    <path d="M19.5 7H0.5" stroke="#111111" strokeMiterlimit="10" strokeLinecap="round" />
    <path d="M19.5 0.5H0.5" stroke="#111111" strokeMiterlimit="10" strokeLinecap="round" />
  </svg>
);

export default BurgerMenu;
